import React, { useEffect, useState } from 'react';
import '../../App.css'
import { FaAngleDoubleRight, FaEye } from 'react-icons/fa';
import boxBg from '../../Assets/bg-boxstar.png'
// import bgLight from '../../Assets/elipse.png'
import {
  Modal,
  Ripple,
  Rating,
  initTE,
} from "tw-elements";
import { Link } from 'react-router-dom';

const Projects = () => {

  const [projects, setProjects] = useState([]);
  initTE({ Modal, Rating, Ripple });





  // console.log(projects);
  useEffect(() => {

    fetch('/Projects.json')
      .then((response) => response.json())
      .then((result) => {
        // Update the state with the loaded data
        setProjects(result);
      })
      .catch((error) => {
        console.error('Error loading data:', error);
      });

  }, []);

  return (

    <div id='#projects' className=" lg:bg-no-repeat overflow-hidden  relative   pb-28 md:pb-32   bg-center  " style={{ backgroundImage: `url(${boxBg})`, }}  >
      <div className=" md:px-10 lg:px-20  max-w-[1400px]  content  mx-auto " >
        <div className=''>
          <div className='text-center '>
            <h1
              data-aos="fade-zoom-in"
              data-aos-easing="ease-in-back"
              data-aos-delay="300"
              data-aos-offset="0"
              className='text-[80px] tracking-[5px]  md:tracking-normal md:text-[130px]  font-extrabold  text-gray-500  text-opacity-20'>Projects</h1>
            <h3 className='text-[35px] md:text-[40px] relative font-semibold text-white -mt-[88px] md:-mt-32'>My Works</h3>
            <div class="flex -mt-2 justify-center">
              <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
            </div>
          </div>

          <div className='flex mt-20 md:mt-32 justify-center'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-0 lg:grid-cols-3  '>

              {
                projects?.slice(0, 3).map(project =>
                  <div
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    key={project._id}
                    class="mx-3 mt-10 lg:mt-0  h-auto  flex flex-col self-start rounded-lg text-white bg-gray-500  md:bg-gray-600 bg-opacity-30 md:bg-opacity-25">
                    <a href=" " className='mx-4 -mt-5'>
                      <img
                        class="rounded-lg shadow-none transition-shadow duration-300 ease-in-out hover:shadow-lg hover:shadow-indigo-900 "
                        src={project.image}
                        alt="img" />
                    </a>
                    <div class="p-6">
                      <h5
                        class="mb-2 text-xl font-medium leading-tight   ">
                        {project.project_name}
                      </h5>
                      <p class=" mb-2 text-md   text-gray-400">
                        {project.project_description.slice(0, 100)}...
                      </p>

                      <div className='mt-5 flex justify-start gap-3'>
                        <a href={project.live_site} target='_blank '>
                          <button
                            data-te-ripple-init
                            data-te-ripple-color="light"
                            className="px-3 py-1 animate-btn font-semibold  bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] text-md rounded-[4px]" >
                            <h2 className='  '>Live Preview <FaEye className='inline w-4 h-4 ml-1' /> </h2>
                          </button>
                        </a>
                        {/* open modal  */}
                        <button
                          className="px-3 py-1 font-semibold   bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] text-md rounded-[4px]"
                          data-te-toggle="modal"
                          data-te-target={`#project${project.id}`}
                          data-te-ripple-init
                          data-te-ripple-color="light">
                          View Details <FaAngleDoubleRight className='inline w-4 h-4' />
                        </button>


                        {/* modal body  */}


                        <div
                          data-te-modal-init
                          class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-y-hidden overflow-x-hidden outline-none"
                          id={`project${project.id}`}
                          tabindex={`project${project.id}`}
                          aria-labelledby={`project${project.id}`}
                          aria-hidden="true">
                          <div
                            data-te-modal-dialog-ref
                            class="pointer-events-none relative w-auto translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[0px]:m-0 min-[0px]:h-full min-[0px]:max-w-none">
                            <div
                              class="pointer-events-auto  relative flex w-full flex-col rounded-md bg-[#0c0324] bg-clip-padding text-current shadow-lg outline-none  min-[0px]:h-full min-[0px]:rounded-none min-[0px]:border-0">
                              <div
                                class="flex flex-shrink-0  items-center justify-between rounded-t-md border-b border-gray-600   border-opacity-100 p-4  min-[0px]:rounded-none">
                                {/* <!-- Modal title --> */}
                                <h5
                                  class="text-xl font-medium leading-normal text-white"
                                  id={`project${project.id}`}>
                                  {project.type}
                                </h5>
                                {/* <!-- Close button --> */}
                                <button
                                  type="button"
                                  class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                                  data-te-modal-dismiss
                                  aria-label="Close">

                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    class="h-6 w-6">
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      d="M6 18L18 6M6 6l12 12" />
                                  </svg>
                                </button>


                              </div>
                              <div class="relative p-2 min-[0px]:overflow-y-auto">
                                <div class="flex w-full   md:w-[80%] -mt-2 bg-gray-600 bg-opacity-20 mx-auto items-center ">
                                  <div class="flex flex-col-reverse       p-4 rounded-lg">
                                    <div class="flex flex-col w-full pr-4">
                                      <h2 class="text-2xl mt-5   font-black mb-2 text-gray-200">{project.project_name}</h2>
                                      <p class="text-lg text-justify  text-gray-400">{project.project_description}</p>
                                      <div class="  h-full items-end text-gray-300  ">

                                        {/* technology  */}
                                        <div>
                                          <h3 className='text-2xl mt-4 block text-gray-300 font-bold'>Technologies</h3>
                                          <div className='flex flex-wrap'>
                                            {
                                              project.technologies?.map((technology, i) => <div
                                                data-te-chip-init
                                                data-te-ripple-init
                                                class="  my-[8px] mr-2 flex flex-wrap h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-gray-500 bg-opacity-25 px-[12px] py-0 text-[13px]    text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none "
                                              >
                                                {technology}
                                              </div>)

                                            }

                                          </div>
                                        </div>

                                        {/* link buttons  */}

                                        <h3 className='text-2xl mt-4 block text-gray-300 font-bold'>Links</h3>
                                        <div className='mt-2  flex-wrap  flex justify-start gap-5 item-center self-center'>

                                          {/* github code buttons  */}

                                          {/* Client code   */}
                                          <button
                                            data-te-ripple-init
                                            data-te-ripple-color="light"
                                            class="text-sm font-semibold bg-gradient-to-r animate-btn   from-[#4E10FF] to-[#AB17DF] p-2 rounded-sm flex items-center space-x-2">
                                            <span><a target='_blank ' href={project.client_code}>Client Code</a></span>
                                            <FaAngleDoubleRight className='inline w-4 h-4' />
                                          </button>

                                          {/* Server code   */}
                                          {
                                            project?.server_code ?  <button
                                            data-te-ripple-init
                                            data-te-ripple-color="light"
                                            class="text-sm font-semibold bg-gradient-to-r  animate-btn  from-[#4E10FF] to-[#AB17DF] p-2 rounded-sm flex items-center space-x-2">
                                            <span><a target='_blank ' href={project.server_code}>Server Code</a></span>
                                            <FaAngleDoubleRight className='inline w-4 h-4' />
                                          </button> : ""
                                          }

                                          {/* live preview button  */}
                                          <button
                                            data-te-ripple-init
                                            data-te-ripple-color="light"
                                            class="text-sm font-semibold animate-btn md:my-0 bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] p-2 rounded-sm flex items-center space-x-2">
                                            <span><a target='_blank ' href={project.live_site}>Live Preview</a></span>
                                            <FaEye className='inline w-4 h-4 ml-1' />
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <div class=" w-full  ">
                                      <img class="w-full    rounded-lg  " src={project.image} alt="" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }

            </div>
          </div>
            <div className='flex justify-center pt-16'>
            <Link to={'/all-projects'}>
              <button
                className="px-3 py-2 mx-auto animate-btn  font-semibold text-white   bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] text-lg rounded-[4px]"
                data-te-ripple-init
                data-te-ripple-color="light">
                More Projects <FaAngleDoubleRight className='inline w-4 h-4' />
              </button>
              </Link>
            </div>
        </div>
      </div>



      {/* for components work   */}
      <button
        type="button"
        class="inline-block hidden rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
        data-te-toggle="modal"
        data-te-target="#leftTopModal"
        data-te-ripple-init
        data-te-ripple-color="light">
        Top Left
      </button>


      <div
        data-te-modal-init
        class="fixed  left-0 top-0 z-[1055] hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
        id="leftTopModal"
        tabindex="-1"
        aria-labelledby="leftTopModalLabel"
        aria-hidden="true">
        <div
          data-te-modal-dialog-ref
          class="pointer-events-none absolute left-7 h-auto w-full translate-x-[-100%] opacity-0 transition-all duration-300 ease-in-out min-[576px]:mx-auto min-[576px]:mt-7 min-[576px]:max-w-[500px]">
          <div
            class="min-[576px]:shadow-[0_0.5rem_1rem_rgba(#000, 0.15)] pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600">
            <div
              class="flex flex-shrink-0 items-center justify-between rounded-t-md bg-primary-600 p-4 dark:border-b dark:border-neutral-500 dark:bg-transparent">
              <h5
                class="text-xl font-medium leading-normal text-white"
                id="leftTopModalLabel">
                Modal title
              </h5>
              <button
                type="button"
                class="box-content rounded-none border-none text-white hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                data-te-modal-dismiss
                aria-label="Close">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="h-6 w-6">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div
              class="relative flex flex-auto flex-wrap justify-center p-4"
              data-te-modal-body-ref>
              <span class="text-primary [&>svg]:h-16 [&>svg]:w-14">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z"
                    clip-rule="evenodd" />
                </svg>
              </span>
              <p class="p-4 text-center">
                Do you want to receive the push notification about the newest
                posts?
              </p>
            </div>
            <div
              class="flex flex-shrink-0 flex-wrap items-center justify-center rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50">
              <button
                type="button"
                class="inline-block rounded bg-primary-100 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-primary-700 transition duration-150 ease-in-out hover:bg-primary-accent-100 focus:bg-primary-accent-100 focus:outline-none focus:ring-0 active:bg-primary-accent-200"
                data-te-modal-dismiss
                data-te-ripple-init
                data-te-ripple-color="light">
                No
              </button>
              <button
                type="button"
                class="ml-1 inline-block rounded bg-primary px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                data-te-ripple-init
                data-te-ripple-color="light">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* for components work   */}

    </div>

  );
};

export default Projects;